export default "__VITE_ASSET__538d145b__"